/**
 * Imports
 */

// Make sure Jquery is working with the $ alias
$ = jQuery;

// Loop through all the game-mode sliders
$(".game-mode-slider").each(function () {
  var $slider = $(this);
  var $dotsContainer = $slider.closest(".game-mode").find(".slick-slider-dots");
  var $arrowsContainer = $slider
    .closest(".game-mode")
    .find(".slick-arrows-here");

  // HTML for custom arrows
  var customPrevArrow = `<span class="slick-prev-cs"><img alt="slick-arrow" src="${theme_url}/src/img/icons/arrow-no-border.svg"></span>`;
  var customNextArrow = `<span class="slick-next-cs"><img alt="slick-arrow" src="${theme_url}/src/img/icons/arrow-no-border.svg"></span>`;

  // Append arrows before and after the dots container
  $arrowsContainer.append(customPrevArrow);
  $arrowsContainer.prepend(customNextArrow);

  $slider.slick({
    dots: false,
    infinite: true,
    speed: 300,
    arrows: true,
    slidesToShow: 1,
    adaptiveHeight: true,
    // autoplay: true,
    fade: true,
    autoplaySpeed: 5000,
    lazyLoad: "ondemand",
    appendDots: $dotsContainer,
    prevArrow: $arrowsContainer.parent().find(".slick-prev-cs"), // Use custom previous arrow
    nextArrow: $arrowsContainer.parent().find(".slick-next-cs"), // Use custom next arrow
  });

  $(window).trigger("resize");
});

// Toy Customization slider
$(".box-images-slider").slick({
  dots: false,
  arrows: true,
  prevArrow: `<img alt="slick-arrow" class='slick-prev' src='${theme_url}/dist/img/icons/arrow.svg'>`,
  nextArrow: `<img alt="slick-arrow" class='slick-next' src='${theme_url}/dist/img/icons/arrow.svg'>`,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  adaptiveHeight: true,
  autoplay: true,
  autoplaySpeed: 5000,
  asNavFor: ".customize-title-slider",
});

// Toy Customization slider
$(".customize-title-slider").slick({
  dots: false,
  arrows: false,
  infinite: true,
  speed: 300,
  fade: true,
  slidesToShow: 1,
  adaptiveHeight: true,
});

// Characters slider (GoodVSEvil)
$(".characters-slider").slick({
  dots: false,
  arrows: true,
  prevArrow: `<img alt="slick-arrow" class='slick-prev' src='${theme_url}/dist/img/icons/arrow.svg'>`,
  nextArrow: `<img alt="slick-arrow" class='slick-next' src='${theme_url}/dist/img/icons/arrow.svg'>`,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  adaptiveHeight: true,
  autoplay: false,
  fade: true,
  asNavFor: ".character-info-slider",
});

// Characters slider (GoodVSEvil)
$(".character-info-slider").slick({
  dots: false,
  arrows: false,
  fade: true,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  adaptiveHeight: true,
  autoplay: false,
  asNavFor: ".characters-slider",
});

$("document").ready(function () {
  // Event which makes the .customize-icon-border class follow the active slide
  $(".unlocks-item-state").click(function () {
    var index = $(this).attr("data-index");
    $(".unlocks-item-state").removeClass("customize-icon-border");
    $(this).addClass("customize-icon-border");
    $(".box-images-slider").slick("slickGoTo", index);
  });

  // Event which makes the .customize-icon-border class follow the active slide
  $(".box-images-slider").on(
    "afterChange",
    function (event, slick, currentSlide) {
      $(".unlocks-item-state").removeClass("customize-icon-border");
      $(".unlocks-item-state[data-index=" + currentSlide + "]").addClass(
        "customize-icon-border",
      );
    },
  );

  // Event which makes the .customize-icon-border class follow the active slide
  $(".character-info-slider").on(
    "afterChange",
    function (event, slick, currentSlide) {
      $(".meet-the-characters").toggleClass("active");
    },
  );

  // When we have scrolled 100px down the page, add the class "scrolled" to the body
  $(window).scroll(function () {
    if ($(window).scrollTop() > 100) {
      $("body").addClass("scrolled");
    } else {
      $("body").removeClass("scrolled");
    }
  });

  // When we click on a faq-item, toggle the open class and show/hide the faq-item-body
  $(".faq-item").click(function () {
    if ($(this).hasClass("open")) {
      $(this).find("img").css("transform", "rotate(-180deg)");
    } else {
      $(this).find("img").css("transform", "rotate(180deg)");
    }

    $(this).toggleClass("open");
    $(this).find(".faq-item-body").toggle();
  });

  // When we click on close-btn, close the modal
  $(".close-btn").click(function () {
    $(".xbox-banner-popup").fadeOut();
  });

  // When we click on show-xbox-popup, show the modal
  $(".show-xbox-popup").click(function (e) {
    e.preventDefault();
    $(".xbox-banner-popup").fadeIn();
    $(".header-menu-slide").slideUp("");
  });

  // When we click on menu-btn, show the menu
  $(".menu-btn").click(function () {
    $(".header-menu-slide").slideToggle("");
  });

  // When we click on close-btn-menu, close the menu
  $(".close-btn-menu").click(function () {
    $(".header-menu-slide").slideToggle("");
  });

  // Scroll function
  $(".scroll-to").click(function (e) {
    e.preventDefault();
    var target = $(this).attr("href");
    $("html, body").animate(
      {
        scrollTop: $(target).offset().top - $(".navbar").outerHeight() - 15,
      },
      500,
    );
  });

  // Video background for the hero section
  if ($("body").hasClass("home")) {
    var videoSource =
      theme_url + "/src/img/content/hero-trailer/hero-trailer.mp4";
    var maxWidthForMobile = 768;
    var videoElement = $(
      '<video class="hero-video w-full h-full object-cover" loop autoplay muted><source src="' +
        videoSource +
        '" type="video/mp4">Your browser does not support the video tag.</video>',
    );
    var videoContainer = $(".overlay").first();

    function handleVideoDisplay() {
      // Remove video for mobile devices
      if (window.innerWidth <= maxWidthForMobile) {
        $(".hero-video").remove();
      } else {
        // Add video for larger devices if it's not already there
        if ($(".hero-video").length === 0) {
          videoContainer.prepend(videoElement);

          // Play the video
          $(".hero-video").get(0).play();
        }
      }
    }

    // Run the function on initial load and on window resize
    handleVideoDisplay();

    $(window).on("resize", handleVideoDisplay);
  }

  // Set the height of the triangle background effect on the hero section
  function triangleBackgroundHeight() {
    var triangleBackground = $(".triangle-background");
    var triangleHeight = triangleBackground.outerHeight() + "px";

    // Set the CSS variable
    triangleBackground.css("--triangle-height", triangleHeight);
  }

  // Run the function on initial load and on window resize
  $(document).ready(triangleBackgroundHeight);
  $(window).resize(triangleBackgroundHeight);

  // Match the height of the game-mode-content elements
  $(".gamemode-content").matchHeight();

  // If the body has been loaded, reslick the sliders
  $("body").on("loaded", function () {
    $(".box-images-slider").slick("refresh");
    $(".customize-title-slider").slick("refresh");
    $(".characters-slider").slick("refresh");
    $(".character-info-slider").slick("refresh");
  });
});
